import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { LogoLockup } from "@/components/Logo";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";

const PROVINCES = ["Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Nova Scotia", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan", "Other"];

export default function Onboarding() {
  const { refresh, user, org } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", primary_contact: user?.full_name || "", province: "Ontario", city: "", num_locations: 1, currency: "CAD" });
  const [busy, setBusy] = useState(false);
  const on = (k) => (e) => setForm({ ...form, [k]: k === "num_locations" ? Number(e.target.value) : e.target.value });

  if (org) return <Navigate to="/app" replace />;

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/organizations", form);
      await refresh();
      toast.success("Dealership created.");
      nav("/app/upload", { replace: true });
    } catch (err) { toast.error(err?.response?.data?.detail || "Failed to create dealership"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[var(--tm-off)] p-5">
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center justify-between mb-8"><LogoLockup /><span className="text-xs uppercase tracking-wider text-[#3B424B] font-semibold">Step 1 · Dealership</span></div>
        <div className="tm-card p-6 sm:p-8 bg-white">
          <h1 className="text-2xl font-bold">Set up your dealership</h1>
          <p className="mt-2 text-sm text-[#3B424B]">This helps TreadMargin scope your data and prepare your dashboard. You can add more locations later.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><label className="tm-label">Dealership name *</label><input required className="tm-input" value={form.name} onChange={on("name")} data-testid="onboarding-name" /></div>
            <div className="grid sm:grid-cols-2 gap-4">
              <div><label className="tm-label">Primary contact *</label><input required className="tm-input" value={form.primary_contact} onChange={on("primary_contact")} data-testid="onboarding-contact" /></div>
              <div><label className="tm-label">Currency</label>
                <select className="tm-input" value={form.currency} onChange={on("currency")} data-testid="onboarding-currency">
                  <option>CAD</option><option>USD</option>
                </select>
              </div>
              <div><label className="tm-label">City *</label><input required className="tm-input" value={form.city} onChange={on("city")} data-testid="onboarding-city" /></div>
              <div><label className="tm-label">Province/State *</label>
                <select className="tm-input" value={form.province} onChange={on("province")} data-testid="onboarding-province">
                  {PROVINCES.map((p) => <option key={p} value={p}>{p}</option>)}
                </select>
              </div>
              <div><label className="tm-label">Number of locations</label><input type="number" min={1} className="tm-input" value={form.num_locations} onChange={on("num_locations")} data-testid="onboarding-locations" /></div>
            </div>
            <button type="submit" disabled={busy} className="tm-btn-primary w-full sm:w-auto" data-testid="onboarding-submit">{busy ? "Creating…" : "Continue to uploads"}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
